import { Validator } from '@vista-digital/validator';
import { carouselConfigValidator } from '../../../subcomponents/carousel/types/config';
import { defaultMemberRewardListActionButtonConfig, memberRewardListActionButtonValidator } from './action-button-config';
import { MemberRewardListMode } from './mode';
export const defaultMemberRewardListCarouselConfig = {
    showDots: false,
    refreshOnUpdate: true,
    settings: {
        slidesToShow: 1.2,
        slidesToScroll: 'auto',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.2
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3.2
                }
            }
        ]
    }
};
export const defaultMemberRewardListConfig = {
    mode: MemberRewardListMode.Grid,
    quantityTagThreshold: 7,
    expiryTagThresholdInDays: 14,
    rewardDetailsExpiryThresholdInDays: 365,
    actionButton: defaultMemberRewardListActionButtonConfig,
    carousel: defaultMemberRewardListCarouselConfig
};
export const memberRewardListConfigValidator = Validator.object({
    mode: Validator.oneOf(Object.values(MemberRewardListMode)),
    quantityTagThreshold: Validator.optional(Validator.number({ min: 0 })),
    expiryTagThresholdInDays: Validator.optional(Validator.number({ min: 0 })),
    rewardDetailsExpiryThresholdInDays: Validator.number({ min: 0 }),
    actionButton: memberRewardListActionButtonValidator,
    rewardFilterFn: Validator.optional(Validator.fn()),
    carousel: carouselConfigValidator
});
